<template>
  <div class="batchDisbursementModal">
    <el-dialog :visible.sync="dialogVisible" class="diglog-card" :title="$t('send_pagements.new_payment')" :close-on-click-modal="false" width="739px">
      <div class="header-line" />
      <div class="section-title">
        {{ $t('send_pagements.batch_payment_details') }}
      </div>
      <div class="section-tip">
        {{ $t('tips.download_and_fill_template_batch_payments') }}
      </div>
      <div class="step">
        <div class="step-item">
          <div class="step-item-left">
            <div class="section-step-title"> {{ $t('send_pagements.excel_worksheet_template_excel') }}</div>
            <div class="section-tip">  {{ $t('tips.latest_template_updated_supported_payment_channels') }}</div>
          </div>
          <div>
            <el-button class="btn-download" type="primary" size="small" icon="el-icon-download" @click="onClickDownloadBtn"> {{ $t('send_pagements.download_template') }}</el-button>
            <div style="margin-top: 10px;">{{ $t('tips.please_upload_latest_template') }}</div>
          </div>

        </div>

        <div class="line-bottom-1px" style="margin-bottom: 32px" />
        <div class="step-item">
          <div class="step-item-left">
            <div class="section-step-title">
              {{ $t('tips.upload_filled_excel_worksheet_template') }}
            </div>
            <div class="section-tip">
              {{ $t('tips.upload_filled_excel_using_template_batch_payments') }}
            </div>
            <div class="section-step-title" style="margin-bottom: 15px;color: #1D3A71;">
              {{ $t('tips.following_three_situations_cause_fail') }}
            </div>
            <div class="situations-tip">
              {{ $t('tips.spaces_in_the_amount') }}
            </div>
            <div class="situations-tip">
              {{ $t('tips.spaces_in_the_email_address') }}
            </div>
            <div v-if="$store.getters.curCountry.country_code !== 'RU'" class="situations-tip">
              {{ walletAccountNumberTip }}
            </div>
          </div>
          <div><UploadExcelFile :reference-batch-no="reference_batch_no" @templateFileSuccess="templateFileSuccess" @templateFileFail="getReferenceBatchNo" v-on="$listeners" /></div>
        </div>
        <!-- <div class="step-item">
          <div class="step-item-title">Batch reference</div>
          <div> <el-input v-model="batchDisbursement.remark" type="text" autocomplete="off" /></div>
        </div> -->
      </div>

      <!-- <div slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="submiting" class="btn-submit" @click="onClickSubmitBtn('form')">{{ $t('components.submit') }}</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import { fetchReferenceBatchNo } from '@/api/online-transaction/online-transaction.js'
import { download } from '@/utils/common'
export default {
  name: 'Single_Disbursement_Modal',
  components: {
    UploadExcelFile: () => import('../file/PayoutUploadExcelFile.vue')
  },
  props: {
    merchantInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    balance: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      batchDisbursement: { withdrawMoney: 0 },
      dialogVisible: false, // 控制弹框显示隐藏
      submiting: false,
      reference_batch_no: null
    }
  },
  computed: {
    walletAccountNumberTip() {
      const tipMap = {
        ID: this.$t('tips.wallet_account_number_not_start_with_08'),
        TH: this.$t('tips.wallet_account_number_rule'),
        AE: this.$t('tips.wallet_account_number_not_start_with_05'),
        MY: this.$t('tips.wallet_account_number_not_start_with_01'),
        SA: this.$t('tips.wallet_account_number_not_start_with_05')
      }
      const countryCode = this.$store.getters.curCountry.country_code
      return tipMap[countryCode] || this.$t('tips.wallet_account_number_not_start_with_09')
    }
  },
  methods: {
    // 改变弹框状态
    showModal() {
      this.reference_batch_no = null
      this.getReferenceBatchNo()
      this.dialogVisible = true
    },
    getReferenceBatchNo() {
      fetchReferenceBatchNo().then(res => {
        if (res.code === 10000) {
          this.reference_batch_no = res.data
        }
      })
    },
    templateFileSuccess() {
      this.dialogVisible = false
      // this.$store.commit('app/SET_SHOW_DOWNLOAD_LIST', true)
      this.$message({ type: 'success', showClose: true, duration: 5000, message: 'Upload completed, the Results Report can be downloaded in ‘Batch Payment Details’ module.' })
      this.$emit('updateList')
    },
    onClickDownloadBtn() {
      let url = ''
      switch (this.$store.getters.curCountry.country_code) {
        case 'PH':
          url = 'https://ulock-public.s3.ap-southeast-1.amazonaws.com/source/Batch_SendPayments_Template_PH_V1.1.xlsx'
          break
        case 'TH':
          url = 'https://ulock-public.s3.ap-southeast-1.amazonaws.com/source/Batch_SendPayments_Template_TH_V1.1.xlsx'
          break
        case 'ID':
          url = 'https://ulock-public.s3.ap-southeast-1.amazonaws.com/source/Batch_SendPayments_Template_ID_V1.1.xlsx'
          break
        case 'AE':
          url = 'https://ulock-public.s3.ap-southeast-1.amazonaws.com/source/Batch_SendPayments_Template_AE_V1.1.xlsx'
          break
        case 'SA':
          url = 'https://ulock-public.s3.ap-southeast-1.amazonaws.com/source/Batch_SendPayments_Template_SA_V1.1.xlsx'
          break
        case 'MY':
          url = 'https://ulock-public.s3.ap-southeast-1.amazonaws.com/source/Batch_SendPayments_Template_MY_V1.1.xlsx'
          break
        case 'RU':
          url = 'https://ulock-public.s3.ap-southeast-1.amazonaws.com/source/Batch_SendPayments_Template_RU_V1.1.xlsx'
          break
        case 'VN':
          url = 'https://ulock-public.s3.ap-southeast-1.amazonaws.com/source/Batch_SendPayments_Template_VN_V1.0.xlsx'
          break
        default:
          break
      }
      download(url, '_blank')
    }
  }
}
</script>

<style scoped>
.batchDisbursementModal{
  word-break: keep-all;
}
.step-item{
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.step-item-left{
  width: 350px;
  word-break: keep-all;
}
.section-step-title{
  margin-bottom: 12px;
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 1.2;
  color: #1D3A71;
}
.situations-tip{
  margin-bottom: 10px;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  color: #71110e;
}
.btn-download{
  font-weight: 400;
  font-size: 15px;
}
.tip{
  font-size: 14px;
  font-weight: 400;
  color: #303133;
}
.dialog-footer{
  margin-top: -16px;
  text-align: center;
}
.btn-submit{
  margin-bottom: 4px;
  width: 120px;
  height: 40px;
  background: #0F68E0;
  border-radius: 100px;
}
</style>
